export default __webpack_public_path__ + "static/media/hero@2x.7b2cb3a4.png";